import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
// import authenService from "../services/authenService";
// import constants from "../constants";
import h from "../services/h";
import vbNotificationService from "../services/vbNotificationService";
import getWorkspaceAppsService from "../services/getWorkspaceAppsService";
import outgoingDocs from "./modules/outgoing-docs";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  // strict: debug,
  state: {
    workspaceApps: [],
    tenantLogoUrl: null,
    user: null,
    userDeptRoles: null,
    userDeptRoleId: null,
    lockedUserDeptRole: null,
    globalDeptRoles: null,
    tenantData: null,
    notificationsUnreadCount: 0,
    notifies: [],
    pageable: {
      page: 0,
      size: 10,
      sort: "createTime,desc"
    }

  },
  mutations: {
    // loadIncomingDocIsSeen(state) {
    //   // vbIncomingDocUserViewService.count(null, null, null,
    //   //   {isRead: 0}).then((res) => {
    //   //     state.incomingDocIsSeen = res.data
    //   //   }
    //   // )
    //   dashBoardService
    //     .getIncomingDocsDashBoard({page: 0, size: 10, sort: "docDate,desc"})
    //     .then(response => {
    //       state.incomingDocIsSeen = response.data.unreadDocsCount;
    //     });
    // },
    // subCountIncomingDocIsSeen(state) {
    //   state.incomingDocIsSeen -= 1;
    // },
    // loadOutgoingDocIsSeen(state) {
    //   // vbOutgoingDocUserViewService.count(null, null, null,
    //   //   {isRead: 0}).then(res => {
    //   //     state.outgoingDocIsSeen = res.data
    //   //   }
    //   // )
    //   dashBoardService
    //     .getOutgoingDocsDashBoard({
    //       page: 0,
    //       size: 10,
    //       sort: "createTime,desc"
    //     })
    //     .then(response => {
    //       state.outgoingDocIsSeen  = response.data.unreadDocsCount;
    //     });
    // },
    // subCountOutgoingDocIsSeen(state) {
    //   console.log('subCountOutgoingDocIsSeen')
    //   state.outgoingDocIsSeen -= 1;
    // },
    setNameRoute(state, payload) {
      state.nameRoute = payload;
    },

    loadMore(state, data) {
      state.notifies = state.notifies.concat(data);
    },

    flushNoti(state) {
      state.notifies = [];
    },

    login(state, loginData) {
      state.user = loginData.user;
      state.userDeptRoles = loginData.userDeptRoles;
    },

    globalRoles(state, globalDeptRoles) {
      state.globalDeptRoles = globalDeptRoles;
      // console.log('state.globalDeptRoles',state.globalDeptRoles)
    },

    setTenantData(state, tenantData) {
      state.tenantData = tenantData;
    },

    getWorkspaceApps(state){
      getWorkspaceAppsService.getWorkspaceApps().then(response => {
        // console.log(response);
        state.workspaceApps = response.data;
      })
    },

    getTenantLogo(state){
      getWorkspaceAppsService.getTenantLogo().then(response => {
        // console.log(response);
        state.tenantLogoUrl = response.data;
      })
    },

    changeUserDeptRole(state, userDeptRoleId) {
      // console.log(state);
      state.userDeptRoleId = userDeptRoleId;
      // authenService.store(
      //   constants.STORAGE_KEY.USER_DEPT_ROLE_ID,
      //   state.userDeptRoleId
      // );
      // vbNotificationService.findAll(state.pageable).then(response => {
      //   state.notifies = response.data;
      // });
      vbNotificationService.countUnSeen()
        .then(response => {
          state.notificationsUnreadCount = response.data;
        });

      //load thong tin notify;
    },
    setIncomingDocCount(state, payload) {
      state.incomingDocCount = payload.data;
    },
    subCount(state) {
      state.notificationsUnreadCount -= 1;
    },

    startLoading(state) {
      state.isLoadingFlag++;
    },

    stopLoading(state) {
      state.isLoadingFlag--;
    },

    setFullScreen(state) {
      state.fullScreen = true;
    },
    setHalfScreen(state) {
      state.fullScreen = false;
    },
    setUserDeptRoleLocked(state, userDeptRoles) {
      state.lockedUserDeptRole = userDeptRoles;
    }
  },
  actions: {},
  getters: {
    userDeptRoles: state => state.userDeptRoles,
    user: state => state.user,
    workspaceApps: state => state.workspaceApps,
    tenantLogoUrl: state => state.tenantLogoUrl,
    notificationsUnreadCount: state => state.notificationsUnreadCount,
    userDeptRoleId: state => state.userDeptRoleId,
    lockedUserDeptRole: state => state.lockedUserDeptRole,
    userDeptRole: state => {
      return h.find(
        state.userDeptRoles,
        userDeptRole => userDeptRole.id === state.userDeptRoleId
      );
    },
    globalRoles: state => state.globalDeptRoles,
    tenantData: state => state.tenantData,
    notifies: state => state.notifies,
    // incomingDocIsSeen: state => state.incomingDocIsSeen,
    // outgoingDocIsSeen: state => state.outgoingDocIsSeen
  },
  plugins: debug ? [createLogger()] : [],
  modules: {
    outgoingDocs,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js